/// <amd-module name="Wiki/Overview/Utils/WikiHelper" />

import { format } from "VSS/Core/Util/String";
import { IVssPageContext } from "VSS/Platform/Context";
import { copyToClipboard } from "VSSUI/Clipboard";

import { IGlobalMessagesService } from "TFS/GlobalBanner/GlobalMessagesService";

import { IVssContributionEventService, IVssContributionService } from "VSS/Platform/Contribution";
import { WikiPage } from "Wiki/Clients/Wiki/Contracts/Wiki";
import * as Resources from "Wiki/Overview/Resources";
import { RepoConstants } from "Wiki/ViewCommon/Constants";
import { WikiPageInfo, WikiPageInfoWithName } from "Wiki/ViewCommon/Contracts";
import { getFileName, getLinkFromPath, getParentPath } from "Wiki/ViewCommon/Utils/PathHelper";

export function copyPagePathToClipboard(pageContext: IVssPageContext, path: string): void {
    // This path has to adhere server side path rules
    const mdPath = format("[{0}]({1})", getFileName(path), getLinkFromPath(path));
    copyToClipboard(mdPath);
    const messageService = pageContext.getService<IGlobalMessagesService>("IGlobalMessagesService");
    messageService.addToast({ message: Resources.OnCopyPagePathMessage, duration: 3000 });
}

/**
 * Returns true if the given page is a root page
 * @param pagePath : assumes page path format to be '/path' - no trailing slashes
 */
export function isTopLevelPage(pagePath: string): boolean {
    return pagePath.lastIndexOf(RepoConstants.PathSeparator) === 0;
}

export function getPageInfoWithName(pageInfo: WikiPageInfo): WikiPageInfoWithName {
    return {
        content: pageInfo.content,
        pageId: pageInfo.id,
        version: pageInfo.version,
        pageName: getFileName(pageInfo.path),
        parentPath: getParentPath(pageInfo.path)
    };
}

/**
 * returns true if the page doesnot have a md file corresponding to it
 * @param page
 */
export function isFolderAssociatedPage(page: WikiPage): boolean {
    return (page && page.isParentPage && page.gitItemPath == null) || (page && page.path === RepoConstants.RootPath);
}

/*
 * Call page view data provider to log the page view activity
 */
export function ingestPageView(pageContext: IVssPageContext, wikiId: string, pageId: number, pagePath: string): void {
    //We need to preserve location hash, because it drops in contribution service.
    //This is needed for comment links to work (Bug 1946703)
    let locationHash = location.hash;

    pageContext
        .getService<IVssContributionService>("IVssContributionService")
        .getDataAsync<void>(
            "ms.vss-wiki-web.wiki-page-view-data-provider",
            {
                wikiId,
                pageId,
                pagePath
            },
            true
        )
        .then(() => {
            location.hash = locationHash;

            // doing this in this because wiki-page-view-data-provider updates the recent page list in server and this event will fetch the same
            const contributedEventService = pageContext.getService<IVssContributionEventService>("IVssContributionEventService");
            contributedEventService.fireEvent("wikipage-activity", undefined, false);
        });
}
